"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
  Global gutters for Rebranding
  They are provided in pixels as raw numbers so consumers can convert them to any unit.
*/
var GUTTERS = {
  desktop: 42,
  mobile: 24
};
var _default = GUTTERS;
exports["default"] = _default;